import translations from "mock-data/translation";

// Set to false in .env.local (then restart/rebuild) to restore type-only labels.
export const CUSTOM_CRAFT_TITLES_ENABLED =
    String(process.env.REACT_APP_CRAFT_CUSTOM_TITLES_ENABLED).trim().toLowerCase() !== "false";

const defaultTitleAliases = {
    additional: [ "Sonstige { number }" ],
    mp_control: [ "MP Kontroll" ],
    collect_graphics: [ "Grafiken sammeln" ]
};

const normalizeTitle = (title) => (title || "").trim().replace(/\s+/g, " ").toLowerCase();

export const isCustomCraftTitle = (type, title, localizeParams) => {
    const normalizedTitle = normalizeTitle(title);

    // Damage is a synthetic tile, not a renamed craft.
    if (!normalizedTitle || !localizeParams || type === "damage") return false;

    const baseType = type.replace(/_\d+$/, "");
    const number = localizeParams.params.number || "";
    const defaultTitles = [
        type,
        type.replace(/_(\d+)$/, " $1"),
        type.replace(/_(\d+)$/, "$1"),
        ...(defaultTitleAliases[baseType] || []),
        ...Object.values(translations).map((dictionary) => dictionary[localizeParams.key])
    ];

    return !defaultTitles.some((defaultTitle) => defaultTitle &&
        normalizeTitle(defaultTitle.replace(/\{\s*number\s*\}/g, number)) === normalizedTitle
    );
};

export const getCustomCraftTitles = (type, titles, localizeParams) => {
    if (!Array.isArray(titles)) return [];

    const seenTitles = new Set();
    const customTitles = [];

    titles.forEach((title) => {
        if (typeof title !== "string") return;

        const displayTitle = title.trim().replace(/\s+/g, " ");
        const normalizedTitle = normalizeTitle(displayTitle);

        if (!normalizedTitle || seenTitles.has(normalizedTitle) ||
            !isCustomCraftTitle(type, displayTitle, localizeParams)) return;

        seenTitles.add(normalizedTitle);
        customTitles.push(displayTitle);
    });

    return customTitles;
};
